import React from "react";
import SideNav from "./SideNav";
import Logo from "../components/common/Logo";
import { Container, Topbar } from "./LayoutNavigateBar.style";

interface ILayout {
  children: React.ReactNode;
}

export default function LayoutNavigateBar(props: ILayout) {
  return (
    <Container>
      <SideNav />
      <Topbar>
        <Logo showsidebar />
      </Topbar>
      {props.children}
    </Container>
  );
}
